import { OrderStatus } from 'app/graphql/generated/cart/graphql';

export const getStatusLabel = (status: OrderStatus): string => {
  switch (status) {
    case OrderStatus.Cancelled:
      return 'Order cancelled';
    case OrderStatus.CancellationInProgress:
      return 'Order cancellation in progress';
    case OrderStatus.CancellationRequested:
      return 'Order cancellation requested';
    case OrderStatus.PartiallyCancelled:
      return 'Order partially cancelled';
    case OrderStatus.Pending:
      return 'Order received';
    case OrderStatus.Processing:
      return 'Order placed';
    case OrderStatus.Succeeded:
      return 'Order placed';
    case OrderStatus.Failed:
      return 'Order failed';
    case OrderStatus.ActionRequired:
      return 'Action required';
    case OrderStatus.ReturnRequested:
      return 'Return requested';
    case OrderStatus.ReturnRequestAccepted:
      return 'Return request accepted';
    case OrderStatus.ReturnApproved:
      return 'Return approved';
    case OrderStatus.ReturnDenied:
      return 'Return denied';
    case OrderStatus.ReturnClosed:
      return 'Return closed';
    default:
      return status;
  }
};

export const getStatusLabelColor = (status: OrderStatus): string => {
  switch (status) {
    case OrderStatus.Cancelled:
    case OrderStatus.Failed:
    case OrderStatus.ReturnDenied:
      return 'details-label fail';
    default:
      return 'details-label success';
  }
};
